import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-budget-report',
  templateUrl: './admin-budget-report.component.html',
  styleUrls: ['./admin-budget-report.component.scss']
})
export class AdminBudgetReportComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }
  redirectToSampleRequestAdminPage() {
    this.router.navigate(['sample-request-admin/home']);
  }
}
